<div class="d-flex mb-4">
  <div class="col-6">
    <div class="mb-4">
      <span class="fw-bold">Nom : </span>
      <span>{{ informationsClient.lastName }}</span>
    </div>

    <div class="mb-4">
      <span class="fw-bold">Téléphone : </span>
      <span>{{ informationsClient.phone }}</span>
    </div>

    <div class="mb-4">
      <span class="fw-bold">Adresse : </span>
      <span>{{ informationsClient.address }}</span>
    </div>

    <div>
      <span class="fw-bold">Code postal : </span>
      <span>{{ informationsClient.postalCode }}</span>
    </div>
  </div>

  <div class="d-flex flex-column justify-content-between">
    <div class="">
      <div class="mb-4">
        <span class="fw-bold">Prénom : </span>
        <span>{{ informationsClient.firstName }}</span>
      </div>

      <div class="mb-4">
        <span class="fw-bold">Email : </span>
        <span>{{ informationsClient.email }}</span>
      </div>
    </div>

    <div>
      <div>
        <span class="fw-bold">Ville : </span>
        <span>{{ informationsClient.city }}</span>
      </div>
    </div>
  </div>
</div>
